import { ids } from '../../utils/staticElementIds';

export const focusTargetClassName = 'flying-focus-target';
export const flyingFocusId = ids.flyingFocus;
export const flyClassName = 'fly';
export const refreshEventName = 'refreshFlyingFocus';
